import React from "react";
import Search from "../search";
import MainMenu from "../main-menu";
import MainMenuLink from "../main-menu-link";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
if (typeof window !== "undefined") {
  import("preline");
}

const searchIndices = [{ name: process.env.GATSBY_INDEX_NAME }];

const Navigation = ({ topMenu, mainMenu }) => {
  console.info("mainMenu", mainMenu);
  return (
    <div className="" id="logo">
      <div className="max-w-screen-xl xxl:max-w-screen-3xl mx-auto lg:flex justify-end items-center gap-5 px-4 min-h-20 pt-4	 hidden">
        {topMenu?.TopMenuItem?.map((item, index) => {
          const image = getImage(item.Icon?.localFile);
          return (
            <div
              className="text-sm font-display text-white font-bold flex items-center gap-2"
              key={index}
            >
              {item.Title === "Search" ? (
                <Search indices={searchIndices} />
              ) : (
                <>
                  <a
                    href={`${item.Url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="drop-shadow-lg"
                  >
                    {item.Title}
                  </a>
                  <GatsbyImage image={image} alt="image" className="w-6" />
                  {index < topMenu.TopMenuItem?.length - 1 && (
                    <span className="text-white"> | </span>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
      <div className="max-w-screen-xl xxl:max-w-screen-3xl mx-auto">
        <header className="relative flex flex-wrap sm:justify-start sm:flex-nowrap z-50 w-full">
          <nav
            className=" w-full mx-auto px-4 lg:flex sm:items-center sm:justify-between lg:mt-0 mt-4"
            aria-label="Global"
          >
            <div className="flex justify-between items-center">
              <div className="shrink-0">
                <Link to="/">
                  <img
                    src="/logo.png"
                    alt="Logo"
                    className="mr-4"
                    width={145}
                    height={145}
                  />
                </Link>
              </div>
              <div className="lg:hidden flex">
                {topMenu?.TopMenuItem?.map((item, index) => {
                  const image = getImage(item.Icon?.localFile);
                  return (
                    <div
                      className="text-sm font-display text-white font-bold flex items-center gap-2  "
                      key={index}
                    >
                      {item.Title === "Search" ? (
                        <div className=" absolute top-[20px] right-[23px] lg:static">
                          <Search
                            indices={searchIndices}
                            device={"mobile"}
                            className=""
                          />
                        </div>
                      ) : (
                        <>
                          <a
                            href={`${item.Url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.Title}
                          </a>
                          <GatsbyImage
                            image={image}
                            alt="image"
                            className="w-6"
                          />
                          {index < topMenu.TopMenuItem?.length - 1 && (
                            <span className="text-white"> | </span>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}

                <button
                  type="button"
                  className="shrink-0 hs-collapse-toggle p-2 inline-flex justify-center items-center gap-2 rounded-md align-middle text-white"
                  data-hs-collapse="#navbar-mega-menu-collapse-unstyled"
                  aria-controls="navbar-mega-menu-collapse-unstyled"
                  aria-label="Toggle navigation"
                >
                  <svg
                    className="hs-collapse-open:hidden w-10 h-10"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                    />
                  </svg>
                  <svg
                    className="hs-collapse-open:block hidden w-10 h-10"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </button>
              </div>
            </div>
            <div
              id="navbar-mega-menu-collapse-unstyled"
              className="hs-collapse hidden overflow-hidden transition-all duration-300 lg:block absolute lg:static w-[94%] lg:w-full"
            >
              <div className="flex flex-col lg:gap-5 gap-y-8 mt-5 lg:flex-row lg:items-center lg:justify-end sm:mt-0 lg:p-0 sm:p-8 p-4 rounded-xl bg-white lg:bg-opacity-0 ">
                {mainMenu?.map((item, index) => {
                  return (
                    <>
                      {item.__component === "menu.menu-dropdown" ? (
                        <MainMenu data={item} index={index} />
                      ) : (
                        <MainMenuLink data={item} index={index} />
                      )}
                    </>
                  );
                })}
                <div className="lg:hidden block">
                  <button
                    type="button"
                    className="flex items-center justify-between w-full lg:text-white text-teal font-bold sm:text-lg font-display"
                  >
                    Member Login
                    <svg
                      width="15"
                      height="21"
                      viewBox="0 0 18 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.2857 10.2857H15.8571V6.85714C15.8571 3.07538 12.7802 0 9 0C5.21975 0 2.14286 3.07538 2.14286 6.85714V10.2857H1.71429C0.766629 10.2857 0 11.0523 0 12V22.2857C0 23.2334 0.766629 24 1.71429 24H16.2857C17.2334 24 18 23.2334 18 22.2857V12C18 11.0523 17.2334 10.2857 16.2857 10.2857ZM5.57143 6.85714C5.57143 4.96702 7.10816 3.42857 9 3.42857C10.8918 3.42857 12.4286 4.96702 12.4286 6.85714V10.2857H5.57143V6.85714Z"
                        fill="teal"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </nav>
        </header>
      </div>
    </div>
  );
};

export default Navigation;
